enum TextureFileType {
  ALBEDO_DIFFUSE = "albedo_diffuse",
  METALIC_ROUGHNESS = "metalic_roughness",
  NORMAL_MAP = "normal_map",
  AMBIENT_OCCLUSION = "ambient_occlusion",
  OTHER = "other",
  NOT_SET = "not_set",
}

export default TextureFileType;
